


























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AnalyseThrealtimedata from "./analyse-realtimedata.vue";
import { number } from "echarts";
class PageRealTimeDataRequest extends PageRequest {
  FilterText: string;
  cId:Number;
  endTime:Date = new Date();
  type:string = "realtime";
}
class PageCompanyRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
  fId:Number;
}
@Component({
  components: {AnalyseThrealtimedata},
})
export default class Floors extends AbpBase {
  pagerequest: PageRealTimeDataRequest = new PageRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId:Number;
  analyseModalShow=false;
  selDateTime:Date=new Date();
  selwarehouselist = [];
  selfloorlist = [];
  searchInt:number = 0;
  wflocation="";
  mac = "";
  eqId = 0;
  get list() {
    return this.$store.state.equipment.list;
  }
  get loading() {
    return this.$store.state.equipment.loading;
  }
  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getwarehouse();
      this.getfloor();
       this.getpage();
  }
  //库区
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    // this.getwarehouse();
    //   this.getfloor();
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
      this.$store.state.equipment.currentPage=1;
       this.getpage();
  }
  //库房
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
      // this.getfloor();
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
      this.$store.state.equipment.currentPage=1;
       this.getpage();
  }
  //楼层
  selfloor(value:Number){
    this.$store.state.equipment.currentPage=1;
    this.getpage();
  }
  async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  pageChange(page: number) {
    this.$store.commit("equipment/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("equipment/setPageSize", pagesize);
    this.getpage();
  }
  getsearch(){
    this.$store.state.thequipment.currentPage=1;
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "equipment/getAll",
      data: this.pagerequest,
    });
  }
GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  analyse() {
    this.selDateTime=this.pagerequest.endTime;
    this.analyseModalShow = true;
  }
  get pageSize() {
    return this.$store.state.equipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.equipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.equipment.currentPage;
  }
  getuserName() {
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
    {
      title: "库房",
      key: "wName",
      render: (h, params) => {
        let wId = params.row.wId;
        let wlist = this.warehouselist();
        for (let entry of wlist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fName",
      render: (h, params) => {
        let fId = params.row.fId;
        let flist = this.floorlist();
        for (let entry of flist) {
          //console.log(entry.id); // 1, "string", false
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "mac",
    },
    {
      title: "位置",
      key: "locationName",
    },
    {
      title: "设备电量",
      key: "electric",
       render: (h, params) => {
        let Electric = params.row.electric;
         let username = this.getuserName();
        if(username !== "admin"){
         if(Electric > 30){
            Electric = "电量充足";
          }
          else if(Electric > 11 && Electric < 31){
             Electric = "电量一般";
          }
          else{
             Electric = "电量不足";
          }
        }
        else{
          Electric= Electric.toString() + "%";
        }
        return h("span",Electric);
      },
    },
    {
      title: "虫子数量",
      key: "numbler",
    },
    // {
    //   title: "设置设备时间",
    //   key: "equtime",
    //   render:(h,params) => {
    //     let addTime ='';
    //     addTime=this.GetDay(params.row.addTime)+ " " +this.GetMinutes(params.row.addTime);
    //     return h("span", addTime);
    //   },
    // },
    {
      title: "更新时间",
      key: "endTime",
       render:(h,params) => {
        let endTime ='';
        endTime=this.GetDay(params.row.endTime)+ " " +this.GetMinutes(params.row.endTime);
        return h("span", endTime);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 100,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "2px",
              },
              on: {
                click: () => {
                 let strtime = params.row.endTime;
                 let datetime1 = new Date(params.row.endTime);
                  if(strtime.toString() == '0001-01-01T00:00:00'){
                    datetime1 = new Date();
                 }
                 this.pagerequest.endTime = datetime1;
                 this.mac = params.row.mac;
                 this.eqId = params.row.id;
                 this.setNames(params.row.ftId,params.row.wId,params.row.fId);
                 this.$store.commit("equipment/analyse", params.row);
                  this.analyse();
                },
              },
            },
            "数据分析"
          ),
         
        ]);
      },
    },
  ];
  setNames(paramftid,paramwid,paramfid){
    let ftid = paramftid;
    let wid = paramwid;
    let fid = paramfid;
    let ftlist = this.factorylist(); 
    for (let entry of ftlist) {
      if(ftid==entry.id){
        ftid=entry.fName;
        break;
      }
    }
    let wlist = this.warehouselist(); 
    for(let entry of wlist) {
      if(wid==entry.id){
        wid=entry.wName;
        break;
      }
    }
    let flist = this.floorlist();
    for(let entry of flist){
      if(fid == entry.id){
        fid = entry.fName;
        break;
      }
    }
    this.wflocation =ftid + wid + fid;
    if(!this.wflocation){
      this.wflocation = "";
    }
  }
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll"
    });
   
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
  created() {
     this.$store.state.thequipment.pageSize=10;
    this.$store.state.thequipment.currentPage=1;
    this.$store.state.thequipment.totalCount=0;
    this.getuserName();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }
     this.getfactory();
      this.getwarehouse();
      this.getfloor();

    this.getpage();
  }
}
